import { render, staticRenderFns } from "./submitReview.vue?vue&type=template&id=2feca412&scoped=true&"
import script from "./submitReview.vue?vue&type=script&lang=js&"
export * from "./submitReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feca412",
  null
  
)

component.options.__file = "submitReview.vue"
export default component.exports